import { AutogenModelTieredChargeTableLookup, AutogenRowTieredChargeTableLookup } from "./autogen/AutogenModelTieredChargeTableLookup";

export class ModelTieredChargeTableLookup extends AutogenModelTieredChargeTableLookup<RowTieredChargeTableLookup> {
	constructor() {
		super(RowTieredChargeTableLookup);
	}
}

export class RowTieredChargeTableLookup extends AutogenRowTieredChargeTableLookup {
}